<template>
    <div class="calc">
        <div class="calc__title">
            <p class="calc__title--title">{{ currentTitle }}</p>
        </div>


        <div class="calc__body">
            <div class="calc__item" v-for="item, ind in hardware" :key="item.id">
                <div class="calc__descr" :class="{ greyBg: item.count > 0,activeDescr : item.isActive }">
                    <p class="calc__descr--text">
                        {{ item.descr }}
                    </p>
                </div>

                <div class="calc__input">
                    <label class="calc__input--label">
                        <transition name="slide-fade" mode="out-in">
                            <p class="calc__input--label-text" v-if="item.count === null">до</p>
                            <p class="calc__input--label-text" v-else>до {{ item.max }}</p>

                        </transition>

                        <input type="number" inputmode="numeric" class="calc__input--num" v-model.trim="item.count"
                            @blur="setNull($event, item.id), setNullIfMinus($event, item.id), item.isActive = false" min="0" :max="item.max"
                             @keydown="deleteE($event)" @input="setMax($event, item.max, item.id)"
                            @focus="item.isActive = true" :placeholder="item.max">

                    </label>

                </div>
            </div>
            <TotalSumm :hardware="hardware" :tariff="tariff" />
        </div>


    </div>
</template>

<script>
export default {
    name: 'CalcMain',
    data() {
        return {
        }
    },
    props: {
        hardware: {
            type: Array,
            default: () => []
        },
        currentTitle: {
            type: String,
            default: '',
        },
        tariff: {
            type: Number,
            default: 0
        }
    },
    methods: {
        setNull(e, ind) {
            // вернем в инпут 0 если ничего не ввели 
            e.target.value == "" ? this.hardware[ind].count = null : false
        },
        setNullIfMinus(e, ind) {
            // запишем в инпут 0 если ввели минусовое значение
            e.target.value < 0 ? this.hardware[ind].count = null : false;
        },

        deleteE(e) {
            // запрет ввода символа 'е'
            if (e.which === 69) {
                e.preventDefault();
            }

        },
        setMax(e, max, ind) {
            // при вводе числа больше максимально возможного присваиваем максимальное
            let inputValue = +e.target.value
            if (inputValue === 0) {
                this.hardware[ind].count = null
            }

            if (inputValue > max) {
                e.preventDefault();
                e.target.value = max
                this.hardware[ind].count = max

            }
        },
    },

}
</script>

<style lang="scss" scoped>
.calc__title {
    text-align: center;
    margin-bottom: 30px;
    max-width: 620px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 30px;
}

.calc__body {
    max-width: 620px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0 auto;
}

.calc__item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 0 10px;
    // height: 100px;
}

.calc__descr {
    // max-width: 300px;
    width: 70%;
    font-size: 15px;
    text-align: left;
    padding: 0 7px;
    min-height: 45px;
    border-radius: 0.3rem;
    display: flex;
    align-items: center;

}

.calc__descr--text {}

.calc__input {
    position: relative;
    width: 30%;

}

.calc__input--label {
    // max-width: 300px;
    // width: 100%;
    display: flex;
    flex-direction: column;
    // background-color: #cfd2d6;
    color: rgb(166, 166, 166);
    padding: 2px 5px;
    border-radius: 0.3rem;
    background-color: rgb(237 237 237);
}

.calc__input--label-text {
    width: 100%;
    height: 20px;
    font-size: 14px;
    text-align: left;
}

.calc__input--num {

    appearance: none;
    background: none;
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    border: 0;
    margin: 0;
    color: #e21414;
    font-weight: 700;
    font-size: 16px;
}

.calc__input--num::placeholder {
    color: rgb(166, 166, 166);
    font-weight: 300;
}

input[type=number]:focus {
    border: 0 !important;
    outline: none !important;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

p {
    margin: 0;
    padding: 0;
}

.slide-fade-enter-active {
    transition: all 0.1s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    //   transform: translateX(10px);
    opacity: 0;
}

.greyBg {
    background-color: #ededed;
}
.activeDescr{
    color: #e21414;
}
.calc__title--title{
    text-transform: uppercase;
    font-weight: 700;
    font-size: 18px;
}
</style>